import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WarningBanner from "app/storybookComponents/WarningBanner";
import Button from "app/storybookComponents/Button";

interface Props {
  buttonLabel: string;
  label: string;
  onActionClick?: () => void;
}

export default function SuccessBanner({
  label,
  onActionClick,
  buttonLabel,
}: Readonly<Props>) {
  return (
    <WarningBanner type="green">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
          {label}
        </div>

        {onActionClick ? (
          <Button
            onClick={() => {
              onActionClick();
            }}
            variant="secondary-blue"
            className="text-nowrap border-0"
          >
            {buttonLabel}
            <FontAwesomeIcon icon="arrow-right" className="ms-2" />
          </Button>
        ) : null}
      </div>
    </WarningBanner>
  );
}
